import { render, staticRenderFns } from "./autoGroup.vue?vue&type=template&id=3c90fb72&scoped=true&"
import script from "./autoGroup.vue?vue&type=script&lang=js&"
export * from "./autoGroup.vue?vue&type=script&lang=js&"
import style0 from "./autoGroup.vue?vue&type=style&index=0&id=3c90fb72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c90fb72",
  null
  
)

export default component.exports